<template>
	<div class="weight-status-widget">
		<h5>Current Weight: {{this.$store.getters.user.weight}} {{current_weight_units}}</h5>
		<p>You've {{weightLost() > 0 ? 'lost' : 'gained'}} {{weightLost() > 0 ? weightLost() : weightLost() * -1}} {{current_weight_units}}
			so far.
			<span v-show="weightLost() > 0">({{goalAchievedPercentage()}}%)</span>
		</p>
		<div class="bmi-figures">
			<img :src="'dist/img/bmi-' + this.$store.getters.user.meta_data.gender + '/obese-c4.png'" :class="getBMIClass() == 6 ? 'selected' : ''"
			/>
			<img :src="'dist/img/bmi-' + this.$store.getters.user.meta_data.gender + '/obese-c3.png'" :class="getBMIClass() == 5 ? 'selected' : ''"
			/>
			<img :src="'dist/img/bmi-' + this.$store.getters.user.meta_data.gender + '/obese-c2.png'" :class="getBMIClass() == 4 ? 'selected' : ''"
			/>
			<img :src="'dist/img/bmi-' + this.$store.getters.user.meta_data.gender + '/obese-c1.png'" :class="getBMIClass() == 3 ? 'selected' : ''"
			/>
			<img :src="'dist/img/bmi-' + this.$store.getters.user.meta_data.gender + '/overweight.png'" :class="getBMIClass() == 2 ? 'selected' : ''"
			/>
			<img :src="'dist/img/bmi-' + this.$store.getters.user.meta_data.gender + '/normal.png'" :class="getBMIClass() == 1 ? 'selected' : ''"
			/>
		</div>
		<p>Your BMI is {{this.$store.getters.user.bmi_index}} - {{this.$store.getters.user.bmi_category}}</p>
		<div class="clearfix"></div>
		<div class="progress" v-show="weightLost() > 0">
			<div class="progress-bar progress-bar-success" :style="'width:' + goalAchievedPercentage() + '%;'" role="progressbar">
				<span class="sr-only"></span>
			</div>
		</div>
		<span class="initial_weight">{{this.$store.getters.user.initial_weight}} {{current_weight_units}}</span>
		<span class="ideal_weight">{{this.$store.getters.user.ideal_weight}} {{current_weight_units}}</span>
	</div>
</template>

<script>

import API from '../../services/api.js';
import {
	mapMutations
} from 'vuex';
const api = new API();

export default {
	data() {
		return {
			current_weight_units: this.$store.getters.user.meta_data.preferred_units == "metric" ? "kg" : "lbs",
		}
	},
	created() {
		
	},
	methods: {
		getBMIClass(){
			switch(this.$store.getters.user.bmi_category){
				case "Normal":
					return 1;
					break;
				case "Overweight":
					return 2;
					break;
				case "Obese Class 1":
					return 3;
					break;
				case "Obese Class 2":
					return 4;
					break;
				case "Obese Class 3":
					return 5;
					break;
				case "Obese Class 4":
					return 6;
					break;
				default:
					return 3;
					break;
			}
		},
		weightLost(){
			return (this.$store.getters.user.initial_weight - this.$store.getters.user.weight).toFixed(1);
		},
		goalAchievedPercentage(){
			var goalWeightLoss = this.$store.getters.user.initial_weight - this.$store.getters.user.ideal_weight;
			return Math.floor((this.weightLost() / goalWeightLoss) * 100);
		}
	}
}
</script>

<style scoped>
.weight-status-widget {
	text-align: center;
}

.bmi-figures {
	padding: 20px 0;
}

.bmi-figures img {
	height: 100px;
	filter: grayscale(100%);
}

.bmi-figures img.selected {
	height: 150px;
	filter: grayscale(0%);
}

.clearfix {
	height: 20px;
}

.initial_weight {
	float: left;
}

.ideal_weight {
	float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/common/WeightStatusWidget.vue